import { EntityIdAdapter } from '@record-it-npm/synchro-common';
export class IdGenerator {
  private static initializedGenerator: IdGenerator | null = null;
  private readonly entityIdAdapter: EntityIdAdapter;
  private initialized: boolean = false;
  constructor({
    entityIdAdapter
  }: {
    entityIdAdapter: EntityIdAdapter;
  }) {
    this.entityIdAdapter = entityIdAdapter;
  }
  public async init(): Promise<void> {
    if (this.initialized) {
      return;
    }
    if (IdGenerator.initializedGenerator) {
      // because they would generate the same ids since they are not synchronized
      throw new Error('only one IdGenerator is allowed to be initialized');
    }
    IdGenerator.initializedGenerator = this;
    this.initialized = true;
  }
  public destroy(): void {
    this.initialized = false;
    IdGenerator.initializedGenerator = null;
  }
  public next(): string {
    if (!this.initialized) {
      throw new Error("can't use the IdGenerator because it isn't initialized");
    }
    return this.entityIdAdapter.generateNewId();
  }
}